import React from 'react';
import { Card, Form, Row, Col } from 'react-bootstrap';

const ContactUsFormSection = ({ data, onUpdate }) => {
  const handleChange = (field, value) => {
    onUpdate({ ...data, [field]: value });
  };

  const updateInfoField = (fieldId, fieldName, value) => {
    const updatedFields = data.infoSection.fields.map(field =>
      field.id === fieldId ? { ...field, fieldName, value } : field
    );
    handleChange('infoSection', { ...data.infoSection, fields: updatedFields });
  };

  const updateFormField = (fieldId, updates) => {
    const updatedFields = data.formSection.formFields.map(field =>
      field.id === fieldId ? { ...field, ...updates } : field
    );
    handleChange('formSection', { ...data.formSection, formFields: updatedFields });
  };

  const updateInfoSection = (field, value) => {
    handleChange('infoSection', { ...data.infoSection, [field]: value });
  };

  const updateFormSection = (field, value) => {
    handleChange('formSection', { ...data.formSection, [field]: value });
  };

  return (
    <Card className="mb-4 shadow">
      <Card.Header className="bg-neutral-gray text-dark d-flex justify-content-between align-items-center">
        <h5 className="mb-0 text-dark">Contact Us Form</h5>
        <Form.Check
          type="checkbox"
          label="Visible"
          checked={data.isVisible}
          onChange={(e) => handleChange('isVisible', e.target.checked)}
          className="mb-0"
        />
      </Card.Header>
      {data.isVisible && (
        <Card.Body>
          {/* Info Section */}
          <h6 className="fw-bold mb-3">Information Section</h6>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Main Heading</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Main Heading"
                  value={data.infoSection?.mainHeading || ''}
                  onChange={(e) => updateInfoSection('mainHeading', e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Sub Heading</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Sub Heading"
                  value={data.infoSection?.subHeading || ''}
                  onChange={(e) => updateInfoSection('subHeading', e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          {/* Info Fields */}
          <h6 className="fw-bold mb-3">Contact Information</h6>
          {data.infoSection?.fields?.map((field) => (
            <div key={field.id} className="border rounded p-3 mb-3 bg-light-subtle">
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-2">
                    <Form.Label>Field Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Field Name"
                      value={field.fieldName}
                      onChange={(e) => updateInfoField(field.id, e.target.value, field.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md={8}>
                  <Form.Group className="mb-2">
                    <Form.Label>Value</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Value"
                      value={field.value}
                      onChange={(e) => updateInfoField(field.id, field.fieldName, e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </div>
          ))}

          {/* Form Section */}
          <h6 className="fw-bold mb-3 mt-4">Form Section</h6>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Heading</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Heading"
                  value={data.formSection?.heading || ''}
                  onChange={(e) => updateFormSection('heading', e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Sub Heading</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Sub Heading"
                  value={data.formSection?.subHeading || ''}
                  onChange={(e) => updateFormSection('subHeading', e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          {/* Form Fields */}
          <h6 className="fw-bold mb-3">Form Fields</h6>
          {data.formSection?.formFields?.map((field) => (
            <div key={field.id} className="border rounded p-3 mb-3 bg-light-subtle">
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-2">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Name"
                      value={field.name}
                      onChange={(e) => updateFormField(field.id, { name: e.target.value })}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-2">
                    <Form.Label>Type</Form.Label>
                    <Form.Select
                      value={field.type}
                      onChange={(e) => updateFormField(field.id, { type: e.target.value })}
                    >
                      <option value="text">Text</option>
                      <option value="email">Email</option>
                      <option value="tel">Phone</option>
                      <option value="textarea">Textarea</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-2">
                    <Form.Label>Placeholder</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Placeholder"
                      value={field.placeholder}
                      onChange={(e) => updateFormField(field.id, { placeholder: e.target.value })}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </div>
          ))}
        </Card.Body>
      )}
    </Card>
  );
};

export default ContactUsFormSection;
